import { GameLobby } from "@/features/rooms/components/GameLobby.tsx";

export const ChessLobby = (
  { user }: {
    user?: {
      id: string;
      reservedRooms?: unknown[];
      isAnonymous?: boolean;
      name?: string;
    };
  },
) => {
  return (
    <div class="relative">
      <a 
        href="/" 
        class="absolute left-4 top-4 btn btn-ghost btn-sm font-black opacity-30 hover:opacity-100 uppercase"
      >
        ← Home
      </a>
      <GameLobby
        title="FARM CHESS"
      description="Classic chess board battles with friends. Support for 4-player chaos!"
      wsUrl="/ws/chess"
      createUrl="/api/chess/rooms"
      joinUrlPrefix="/chess"
      user={user}
      buttonText="Create Game"
      showReserved
    />
    </div>
  );
};
